import React from "react";

import Header from "../components/header";
import Footer from "../components/footer";
import Whatsapp from "../components/whatsapp";

import "../style/privacyTerms.css";

function FAQ() {
    return (
        <React.Fragment>
            <Header />
            
            <div className="terms-container">
                <div className="header">
                    <b>FAQ</b>
                </div>

                <div className="content">
                    <b>O que é o serviço?</b>
                    <span>O serviço de streaming 2K20 oferece uma plataforma que permite aos usuários assistir a canais de televisão ao vivo pela internet. Diferente dos serviços tradicionais de TV a cabo, a 2K20 proporciona a flexibilidade de acessar a programação em tempo real, diretamente de diversos dispositivos, como smartphones, tablets e smart TVs, onde e quando quiser.</span>

                    <b>O que é streaming?</b>
                    <span>Streaming é uma tecnologia que permite a transmissão de áudio e vídeo pela internet em tempo real, sem a necessidade de download completo do arquivo. <br />No caso da 2K20, nosso serviço de streaming oferece acesso a canais ao vivo, permitindo que você assista à programação em tempo real, assim como na TV tradicional.</span>

                    <b>Como funciona?</b>
                    <span>A 2K20 transmite canais de televisão em tempo real pela internet. Além de permitir você a baixar o aplicativo em dispositivos como smartphones e tablets, garantindo acesso fácil à sua programação favorita a qualquer momento.</span>

                    <b>Quais os benefícios e diferenciais da tv a cabo?</b>
                    <span>Variedade de canais; adaptação de qualidade; qualidade de som; flexibilidade de acesso; sem equipamentos adicionais; variedade de pacotes; suporte ao cliente.</span>

                    <b>Em quais dispositivos o aplicativo está disponível?</b>
                    <span>
                        <ul>
                            <li>LG-TV + Monitor TV - Versão WebOSTV 4.5 / TV - Versão WebOSTV 2.3, WebOSTV 4.0, WebOSTV 4.5, WebOSTV 5.0, WebOSTV 6.0 e WebOSTV 7.0.</li>
                            <li>Samsung - Modelos com versão sistema a partir de 2021 (Tizen 6.0) em diante.</li>
                            <li>Android TV - Modelos com sistema Android TV instalado.</li>
                            <li>Google TV- Modelos com Google TV instalado.</li>
                            <li>Roku TV- Modelos com a última versão ROKU instalada (TV ou EXPRESS).</li>
                            <li>Android e IOS - Smartphone com os sistemas operacionais atualizados.</li>
                        </ul>
                    </span>

                    <b>Tem fidelidade?</b>
                    <span>Não, nosso serviço de Streaming não possui fidelidade, podendo ser cancelado mediante a solicitação do usuário.</span>

                    <b>Como funciona a qualidade de transmissão?</b>
                    <span>Em situações normais, o sistema otimiza a qualidade para proporcionar a melhor experiência possível. Apenas em condições muito particulares a de menor qualidade seria ativada, ainda garantindo que você ainda possa acessar o conteúdo, mesmo em situações desafiadoras.</span>

                    <b>Quais recursos não têm no serviço?</b>
                    <span>Barra de pesquisa; pausar, retroceder ou adiantar a programação; e serviço on-demand. A 2K20 Streaming oferece a transmissão de canais ao vivo em tempo real, semelhante à TV tradicional.</span>

                    <b>Existem restrições geográficas?</b>
                    <span>Não existem restrições geográficas para a utilização do serviço de streaming 2K20 Streaming. No entanto, há limitações em relação à venda, que pode variar de acordo com a região.</span>

                    <b>Como funciona a cobrança?</b>
                    <span>A cobrança da mensalidade funciona de forma bem simples: os boletos são enviados diretamente para o seu e-mail cadastrado, mas se tiver qualquer dúvida ou não encontrar o boleto, é só avisar que a gente te ajuda!</span>

                    <b>O serviço tem anúncios?</b>
                    <span>O serviço de streaming 2K20 Streaming não possui anúncios, proporcionando uma experiência de visualização contínua e sem interrupções.</span>

                    <b>Quais as diferenças entre canais abertos e fechados?</b>
                    <span>Abertos - São transmitidos gratuitamente e podem ser acessados por qualquer pessoa com uma antena ou uma conexão de TV. Exemplos incluem canais como Globo, SBT e Record. <br />Fechados- Exigem uma assinatura ou pagamento para acesso. Esses canais geralmente oferecem programação exclusiva, como séries, filmes e eventos esportivos. Exemplos incluem canais como HBO, ESPN e TeleCine.</span>

                    <b>É possível fazer o compartilhamento da conta?</b>
                    <span>Não, o compartilhamento da conta não é permitido. No entanto, você pode conectar até 5 smart's TV ou aparelhos celulares em sua casa usando o mesmo login, garantindo que todos possam desfrutar do conteúdo da 2K20 Streaming em diferentes dispositivos. Dependendo do plano escolhido.</span>

                    <b>Esqueci meu login ou minha senha, o que fazer?</b>
                    <span>Caso tenha esquecido a senha ou o login de acesso, podemos repassar essas informações. No entanto, é possível solicitar a recuperação diretamente no aplicativo, utilizando o botão "esqueci minha senha".</span>

                    <b>Terei a Globo local?</b>
                    <span>Atualmente, nosso canal InterTV é da região do Rio de Janeiro, mas estamos trabalhando para possivelmente oferecer a InterTV de outras regiões.</span>

                    <b>A 2K20 Streaming é legalizada?</b>
                    <span>Sim, a 2K20 Streaming é um serviço legalizado, operando de acordo com as normas e regulamentações brasileiras para a transmissão de conteúdo televisivo.</span>

                    <b>Como posso cancelar minha assinatura?</b>
                    <span>Para cancelar sua assinatura, basta entrar em contato com o nosso suporte, que irá orientar você em todo o processo de forma rápida e simples.</span>

                    <b>Em quantas telas posso assistir a NGT TV simultaneamente?</b>
                    <span>São permitidos o uso de 5 telas a serem usadas ao mesmo tempo.</span>

                </div>
            </div>

            <Whatsapp/>
            <Footer />
        </React.Fragment>
    )
}

export default FAQ;